<template>
    <div>
        <hts-drawer
            v-model="visible"
            :submit="handleSubmitFormAddVehicle"
            :title="$t('labels.addVehicle')"
            :rules="rulesAddVehicle"
            size="large"
            @close="closeOverSide">
            <hts-card :title="$t('labels.generalInformation')">
                <div
                    v-if="dataFormAddVehicle.type === 1"
                    class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                    <hts-select-cooperator
                        v-model="dataFormAddVehicle.fleetVehicle"
                        required
                        type-cooperator="PARTNER"
                        prop="fleetVehicle"
                        name-select="fleetVehicle"
                        :label="$t('labels.fleetVehicle')"
                        @change="handleChangeVehicle" />
                    <hts-form-input
                        v-model="dataFormAddVehicle.licensePlate"
                        :label="$t('labels.vehicleModule.licensePlate')"
                        :required="true"
                        :color="props.color"
                        name="vehicleModule.licensePlate"
                        prop="vehicleModule.licensePlate" />
                </div>
                <template v-if="dataFormAddVehicle.type === 0">
                    <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                        <div class="flex">
                            <hts-form-checkbox
                                v-model="dataFormAddVehicle.containerType"
                                :items="[{ label: $t('labels.vehicleModule.containerType'), value: false }]" />

                            <hts-tooltip class="mt-1">
                                <div>
                                    <span class="font-bold">
                                        {{ $t('labels.containerTypeDetail') }}
                                    </span>
                                </div>
                                <template #reference>
                                    <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                </template>
                            </hts-tooltip>
                        </div>

                        <hts-form-checkbox
                            v-model="dataFormAddVehicle.isGenset"
                            :items="[{ label: $t('labels.vehicleModule.useGenset'), value: false }]" />
                    </div>
                    <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                        <hts-form-input
                            v-model="dataFormAddVehicle.licensePlate"
                            :label="$t('labels.vehicleModule.licensePlate')"
                            :required="true"
                            :color="props.color"
                            name="vehicleModule.licensePlate"
                            prop="vehicleModule.licensePlate" />
                        <hts-form-input
                            v-model="dataFormAddVehicle.manufacture"
                            :label="$t('labels.vehicleModule.manufacture')"
                            :color="props.color"
                            name="vehicleModule.manufacture"
                            prop="vehicleModule.manufacture" />
                        <hts-form-input
                            v-model="dataFormAddVehicle.vehicleLoad"
                            :label="$t('labels.vehicleModule.category.vehicleLoad')"
                            :color="props.color"
                            type="number"
                            name="vehicleModule.category.vehicleLoad"
                            prop="vehicleModule.category.vehicleLoad"
                            @change="handleInputVehicleLoad">
                            <template #custom>
                                <hts-tooltip>
                                    <div>
                                        <span class="font-bold">
                                            {{ $t('labels.vehicleModule.subcriptionVehicleLoad') }}
                                        </span>
                                    </div>
                                    <template #reference>
                                        <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                    </template>
                                </hts-tooltip>
                            </template>
                        </hts-form-input>

                        <hts-form-input
                            v-model="dataFormAddVehicle.weight"
                            :label="$t('labels.vehicleModule.weight')"
                            type="number"
                            :color="props.color"
                            name="vehicleModule.weight"
                            prop="vehicleModule.weight" />

                        <hts-form-date
                            v-model="dataFormAddVehicle.expiredYear"
                            :label="$t('labels.vehicleModule.expiredYear')"
                            :color="props.color"
                            type="year"
                            name="vehicleModule.expiredYear"
                            prop="vehicleModule.expiredYear"
                            @change="updateDepreciationVehicle" />

                        <hts-form-input
                            v-model="dataFormAddVehicle.price"
                            :label="$t('labels.vehicleModule.price')"
                            type="number"
                            :color="props.color"
                            name="vehicleModule.price"
                            prop="vehicleModule.price" />

                        <hts-form-date
                            v-model="dataFormAddVehicle.buyingTime"
                            :label="$t('labels.vehicleModule.buyingTime')"
                            :color="props.color"
                            type="year"
                            name="vehicleModule.buyingTime"
                            prop="vehicleModule.buyingTime"
                            @change="updateDepreciationVehicle" />

                        <hts-form-select
                            v-model="dataFormAddVehicle.licenseType"
                            :label="$t('labels.driverModule.licenseType')"
                            :items="licenseList"
                            key-id="key"
                            key-label="key"
                            key-tooltip="keyDes"
                            :color="props.color"
                            name="driverModule.licenseType"
                            prop="driverModule.licenseType"
                            @change="handelChangeLicenseType" />
                        <div>
                            <hts-form-select
                                v-model="dataFormAddVehicle.driver"
                                :clearable="true"
                                :param-prepare="dataFormAddVehicle.licenseType"
                                :disabled="dataFormAddVehicle.licenseType ? false : true"
                                :label="$t('labels.primaryDriver')"
                                name="driver"
                                prop="driver"
                                key-id="_id"
                                key-label="driverDetail"
                                :query="findDrivers" />
                            <hts-form-select
                                v-model="dataFormAddVehicle.coDriver"
                                :clearable="true"
                                :param-prepare="dataFormAddVehicle.licenseType"
                                :disabled="dataFormAddVehicle.licenseType ? false : true"
                                :label="$t('labels.coDriver')"
                                name="coDriver"
                                prop="coDriver"
                                key-id="_id"
                                key-label="driverDetail"
                                :query="findDrivers" />
                        </div>
                        <div>
                            <hts-select-vehicle-parking
                                v-model="dataFormAddVehicle.parkingNodeId"
                                v-model:text="dataFormAddVehicle.parkingNodeName"
                                required
                                prop="parkingNodeId"
                                name="parkingLot" />
                            <hts-select-tracking-gps
                                v-model="dataFormAddVehicle.gpsTrackingType"
                                required
                                prop="gpsTrackingType"
                                name="gpsTrackingType"
                                :label="$t('labels.gpsTrackingType')" />
                        </div>
                    </div>
                </template>
            </hts-card>
            <div
                v-if="dataFormAddVehicle.type === 0"
                class="mt-1.5">
                <hts-card :title="$t('labels.vehicleModule.tollStationInformation')">
                    <div class="color-theme size-default hts-form-input">
                        <div
                            v-if="dataFormAddVehicle.tollStation.length > 0"
                            class="grid grid-cols-1 gap-4 my-3">
                            <div
                                v-for="(item, index) in dataFormAddVehicle.tollStation"
                                :key="index">
                                <hts-form-disclosure
                                    color="main"
                                    size="large"
                                    :is-have-children="false"
                                    :is-have-remove-icon="true"
                                    is-edit
                                    :disabled="props.disabled"
                                    @remove="handleRemove(index)"
                                    @edit="handleEditTollStation(index, item)">
                                    <template #reference>
                                        <div class="grid grid-cols-1">
                                            <span class="mt-2 text-base">
                                                {{ $t('labels.vehicleModule.tollStationName') }}: {{ item.tollStationName }}
                                            </span>
                                            <span class="mt-2 text-base">
                                                {{ $t('labels.calculatedBy') }}:
                                                {{ item.calculatedBy === 'MONTH' ? $t('labels.month') : item.calculatedBy === 'QUARTER' ? $t('labels.quarter') : '' }}
                                            </span>
                                            <span class="mt-2 text-base">
                                                {{ $t('labels.from') }}: {{ $formatters.date(item.from || 0) }}
                                            </span>
                                            <span class="mt-2 text-base">
                                                {{ $t('labels.to') }}: {{ $formatters.date(item.to || 0) }}
                                            </span>
                                        </div>
                                    </template>
                                </hts-form-disclosure>
                            </div>
                        </div>
                        <div
                            v-if="!props.disabled"
                            class="flex items-center justify-center mt-2">
                            <div
                                class="h-7 w-7 mt-3 cursor-pointer border-2 border-orange-500 rounded-full flex items-center justify-center"
                                @click="handleOpenPopupCreateTollStationPrice">
                                <hi-plus-icon class="h-5 w-5 fill-orange-700" />
                            </div>
                        </div>
                    </div>
                </hts-card>

                <hts-card
                    v-if="checkPermission(layoutPermissions.vehicle_administration)"
                    :title="$t('labels.vehicleModule.administration')">
                    <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                        <hts-form-input
                            v-model="dataFormAddVehicle.fuelConsumption"
                            :label="$t('labels.vehicleModule.fuelConsumption')"
                            type="number"
                            :color="props.color"
                            name="vehicleModule.fuelConsumption"
                            prop="vehicleModule.fuelConsumption" />
                        <hts-form-input
                            v-model="dataFormAddVehicle.priceLiquidation"
                            :label="$t('labels.priceLiquidation')"
                            type="number"
                            :color="props.color"
                            name="priceLiquidation"
                            prop="priceLiquidation" />

                        <div>
                            <hts-form-input
                                v-model="dataFormAddVehicle.depreciationVehicle"
                                :label="$t('labels.vehicleModule.depreciationVehicle')"
                                type="number"
                                :color="props.color"
                                name="vehicleModule.depreciationVehicle"
                                prop="vehicleModule.depreciationVehicle"
                                @change="(value) => depreciationVehicleChange(value)" />
                            <p class="text-error-500 text-xs p-0 m-0 ml-1">
                                {{ showVehicleDepreciationError ? $t('labels.vehicleModule.vehicleDepreciationError') : '' }}
                            </p>
                        </div>

                        <hts-form-input
                            v-model="dataFormAddVehicle.repairingPrice"
                            :label="$t('labels.vehicleModule.repairingPrice')"
                            type="number"
                            :color="props.color"
                            name="repairingPrice"
                            prop="repairingPrice" />
                    </div>
                </hts-card>
            </div>

            <hts-card
                v-if="dataFormAddVehicle.type === 1"
                :title="$t('labels.driverInfo')">
                <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                    <hts-form-input
                        v-model="dataFormAddVehicle.otherCompanyDriver.fullName"
                        :label="$t('labels.fullName')"
                        required
                        :color="color"
                        name="fullName"
                        prop="fullName" />
                    <hts-form-phone
                        v-model="dataFormAddVehicle.otherCompanyDriver.phone"
                        :label="$t('labels.phone')"
                        required
                        prop="phone"
                        name="phone"
                        @updateCode="(val) => (dataFormAddVehicle.otherCompanyDriver.phone.code = val)" />
                    <hts-form-input
                        v-model="dataFormAddVehicle.otherCompanyDriver.idCardNumber"
                        :label="$t('labels.idCardNumber')"
                        required
                        :color="color"
                        name="idCardNumber"
                        prop="idCardNumber" />
                </div>
            </hts-card>
        </hts-drawer>
        <add-category
            ref="showDrawerAddVehicleCategory"
            @refresh-tables="handleInputVehicleLoad" />
        <add-toll-station
            ref="addTollStation"
            @submit="handleAddTollStation" />
        <hts-modal
            v-model="modalConfirmDepreciationVehicle"
            :title="$t('labels.vehicleModule.vehicleDepreciationConfirm')"
            :content="$t('labels.vehicleModule.vehicleDepreciationConfirmDetail')"
            type="confirm"
            @confirm="modalConfirmDepreciationVehicle = false"
            @hide="cancelDepreciationVehicle" />

        <hts-modal
            v-model="openPopupCostingErrorCategory"
            :content="contentPopupAddCategory"
            @hide="() => (openPopupCostingErrorCategory = false)" />
    </div>
</template>

<script setup lang="ts">
import AddTollStation from './add-toll-station.vue'
import form, { IVehicle } from './imports/form'
import { $api, $lodash } from '#imports'
import layoutPermissions from '@/data/permissions/layout-permissions'
import data from '@/pages/trucker-[id]/driver/ignore/imports/data'
import { checkPermission } from '@/utils/permission-check'

const { $formatters } = useNuxtApp()

const { rules } = form

const store = $store()
const { license } = data()
const licenseList = computed(() => license())
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  column: {
    type: Number,
    default: 3
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const visible = ref(false)
const showDrawerAddVehicleCategory = ref()
const openPopupAddCategory = ref(false)
const openAddCategory = () => {
  if (showDrawerAddVehicleCategory.value) {
    openPopupAddCategory.value = false
    showDrawerAddVehicleCategory.value.openAddCategory()
  }
}
const dataFormAddVehicle = reactive<IVehicle>({ ...form.initFormVehicle })

const emits = defineEmits(['close', 'refreshDataTables'])
const tollStation = reactive<Array<{ [key: string]: any }>>([])
const modalConfirmDepreciationVehicle = ref(false)
const open = (type: number) => {
  Object.assign(configCont, store.globalSettings.getGlobalSettings.configCont || {})
  visible.value = true
  dataFormAddVehicle.type = type
  if (dataFormAddVehicle?.otherCompanyDriver) {
    dataFormAddVehicle.otherCompanyDriver.phone = {
      countryCode: 'Vietnam +84',
      phone: '',
      code: '+84'
    }
  }
}

const CContentNoVehicleCatagory = computed(() => {
  return `Bạn không thể tiếp tục thêm mới xe cho xe có trọng tải ${$formatters.formatCurrency(
    dataFormAddVehicle.vehicleLoad || 0
  )} kg. Vui lòng liên hệ admin để thêm loại xe tương ứng.`
})
defineExpose({
  open
})

const closeOverSide = () => {
  visible.value = false
}

const configCont: { [key: string]: any } = reactive({})

const vehicleCategory = ref<{ [key: string]: any }>({})
const contentPopupAddCategory = ref('')
const openPopupCostingErrorCategory = ref(false)
const handleInputVehicleLoad = $lodash.debounce(async (value: number) => {
  const api = $urlAdmin.vehicle.category['find-by-vehicle-tonnage']

  const data: any = await $api(api, {
    uriParams: { KEY: typeof value === 'number' ? value : typeof dataFormAddVehicle.vehicleLoad === 'number' ? dataFormAddVehicle.vehicleLoad : '' }
  })
  const resData: any = data?.data?.value

  if (resData.success) {
    const { oilMaterialAssumption, liquidationValue, repairingPrice } = resData.data

    if ($lodash.isNil(oilMaterialAssumption) || $lodash.isNil(liquidationValue) || $lodash.isNil(repairingPrice)) {
      contentPopupAddCategory.value = `Bạn không thể tiếp tục thêm mới xe cho xe có trọng tải ${$formatters.formatCurrency(
        dataFormAddVehicle.vehicleLoad
      )} kg. Vui lòng liên hệ admin để thêm các thông tin về chi phí cho loại xe có trọng tải tương ứng.`
      openPopupCostingErrorCategory.value = true
      vehicleCategory.value = {}
      dataFormAddVehicle.vehicleType = ''
      dataFormAddVehicle.repairingPrice = null
      dataFormAddVehicle.priceLiquidation = null
      dataFormAddVehicle.fuelConsumption = null
    } else {
      vehicleCategory.value = resData.data || {}
      dataFormAddVehicle.vehicleType = resData.data._id || ''
      dataFormAddVehicle.repairingPrice = repairingPrice || 0
      dataFormAddVehicle.priceLiquidation = liquidationValue || 0
      dataFormAddVehicle.fuelConsumption = oilMaterialAssumption || 0
      openPopupCostingErrorCategory.value = false
      contentPopupAddCategory.value = ''
    }
  }
}, 500)
const addTollStation = ref()
const handleOpenPopupCreateTollStationPrice = () => {
  if (addTollStation.value) {
    addTollStation.value.open()
  }
}

const handleAddTollStation = (data: any, value: string, index: number) => {
  if (!(typeof index === 'number')) {
    dataFormAddVehicle.tollStation.push(data)
  }
  if (typeof index === 'number') {
    dataFormAddVehicle.tollStation[index] = data
  }
}
const handleRemove = (index: number) => {
  dataFormAddVehicle.tollStation.splice(index, 1)
}

const handleEditTollStation = (index: number, data: any) => {
  if (addTollStation.value) {
    addTollStation.value.open(index, data)
  }
}

const handleSubmitFormAddVehicle = async () => {
  if (dataFormAddVehicle.type === 0 && !Object.keys(vehicleCategory.value).length) {
    openPopupAddCategory.value = true
    return
  }

  if (
    $lodash.isNil(vehicleCategory.value?.oilMaterialAssumption ?? null) ||
    $lodash.isNil(vehicleCategory.value.liquidationValue ?? null) ||
    $lodash.isNil(vehicleCategory.value.repairingPrice ?? null)
  ) {
    contentPopupAddCategory.value = `Bạn không thể tiếp tục thêm mới xe cho xe có trọng tải ${$formatters.formatCurrency(
      dataFormAddVehicle.vehicleLoad
    )} kg. Vui lòng liên hệ admin để thêm các thông tin về chi phí cho loại xe có trọng tải tương ứng.`
    openPopupCostingErrorCategory.value = true
    return
  }

  if (dataFormAddVehicle.type !== 0) {
    dataFormAddVehicle.parkingNodeId = null
  }

  dataFormAddVehicle.driver = dataFormAddVehicle.driver || null
  dataFormAddVehicle.coDriver = dataFormAddVehicle.coDriver || null

  if (dataFormAddVehicle.coDriver && !dataFormAddVehicle.driver) {
    process.client && $toast().error('Vui lòng chỉ định tài xế chính trước khi chọn tài xế phụ')
    return
  }

  if (dataFormAddVehicle.driver && dataFormAddVehicle.driver === dataFormAddVehicle.coDriver) {
    process.client && $toast().error('Vui lòng chỉ định tài xế phụ khác tài xế chính')
    return
  }

  const api = $url.vehicle.vehicle.add

  const data: any = await $api(api, { body: { ...dataFormAddVehicle } })
  const resData: any = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('labels.vehicleModule.addSuccess'))
    emits('close')
    emits('refreshDataTables')
    undo()
    visible.value = false
  }
}

const undo = () => {
  Object.assign(dataFormAddVehicle, { ...form.initFormVehicle })
  dataFormAddVehicle.tollStation = []
  vehicleCategory.value = {}
  dataFormAddVehicle.otherCompanyDriver = {
    fullName: '',
    phone: {
      countryCode: '',
      phone: '',
      code: ''
    },
    idCardNumber: ''
  }
}

const rulesAddVehicle = computed(() => {
  const year = new Date().getFullYear()
  let data: { [key: string]: any } = {}
  if (dataFormAddVehicle.type === 0 || (dataFormAddVehicle.typeFleetVehicle && dataFormAddVehicle.typeFleetVehicle.includes('PARTNER'))) {
    Object.assign(data, { ...rules.addVehicle })
    const buyingTime = dataFormAddVehicle.buyingTime && dataFormAddVehicle.buyingTime <= year ? dataFormAddVehicle.buyingTime : 1970
    if (data) {
      data['vehicleModule.buyingTime'] = data['vehicleModule.buyingTime'] + '|min_value:1971|max_value:' + year
      data['vehicleModule.expiredYear'] = data['vehicleModule.expiredYear'] + `|min_value:${Number(buyingTime) > 1970 ? Number(buyingTime) + 1 : 1970}`
      if (checkPermission(layoutPermissions.vehicle_administration)) {
        data['vehicleModule.fuelConsumption'] = 'required|gt:0'

        if (typeof dataFormAddVehicle.priceLiquidation === 'number' && typeof dataFormAddVehicle.price === 'number') {
          if (checkPermission(layoutPermissions.vehicle_administration)) {
            data.priceLiquidation = `required|validationCustom:${
              dataFormAddVehicle.priceLiquidation < dataFormAddVehicle.price
            }--Giá thanh lý phải nhỏ hơn giá mua`
          }

          data['vehicleModule.price'] = `required|validationCustom:${
            dataFormAddVehicle.priceLiquidation < dataFormAddVehicle.price
          }--Giá mua phải lớn hơn giá thanh lý`
        }
      }
      const maxValue = Number(dataFormAddVehicle.expiredYear) - Number(dataFormAddVehicle.buyingTime)
      if (maxValue >= 1 && dataFormAddVehicle.expiredYear && dataFormAddVehicle.buyingTime) {
        data['vehicleModule.depreciationVehicle'] = `integer|min_value:1|max_value:${maxValue}`
      } else {
        data['vehicleModule.depreciationVehicle'] = 'integer|min_value:1'
      }
    }
  }

  if (dataFormAddVehicle.type === 1) {
    data = {
      fleetVehicle: 'required',
      'vehicleModule.licensePlate': 'required',
      fullName: 'required',
      phone: 'required',
      idCardNumber: 'required'
    }
  }
  return data
})

const updateDepreciationVehicle = () => {
  if (!dataFormAddVehicle.buyingTime || !dataFormAddVehicle.expiredYear) {
    return
  }

  dataFormAddVehicle.depreciationVehicle = Number(dataFormAddVehicle.expiredYear) - Number(dataFormAddVehicle.buyingTime)

  if (dataFormAddVehicle.depreciationVehicle < 1) {
    dataFormAddVehicle.depreciationVehicle = 1
  }
}

const showVehicleDepreciationError = computed(() => {
  if (!checkPermission(layoutPermissions.vehicle_administration)) {
    return false
  }

  const depreciationVehicle = Number(dataFormAddVehicle.expiredYear) - Number(dataFormAddVehicle.buyingTime)
  if (depreciationVehicle < 1) {
    return false
  }

  if (dataFormAddVehicle.depreciationVehicle && dataFormAddVehicle.depreciationVehicle < 1) {
    return false
  }

  if (depreciationVehicle < Number(dataFormAddVehicle.depreciationVehicle)) {
    return true
  }
  return false
})

const depreciationVehicleChange = $lodash.debounce(() => {
  if (!checkPermission(layoutPermissions.vehicle_administration)) {
    return
  }
  const expiredYear = Number(dataFormAddVehicle.expiredYear) || undefined
  const buyingTime = Number(dataFormAddVehicle.buyingTime) || undefined
  const depreciationVehicle = Number(dataFormAddVehicle.depreciationVehicle) || undefined

  if (typeof expiredYear !== 'number' || typeof buyingTime !== 'number' || typeof depreciationVehicle !== 'number') {
    return
  }
  if (depreciationVehicle > 0 && depreciationVehicle < expiredYear - buyingTime) {
    modalConfirmDepreciationVehicle.value = true
  }
}, 500)

const cancelDepreciationVehicle = $lodash.debounce(() => {
  const expiredYear = Number(dataFormAddVehicle.expiredYear) || 0
  const buyingTime = Number(dataFormAddVehicle.buyingTime) || 0
  dataFormAddVehicle.depreciationVehicle = expiredYear - buyingTime || 1
})

const handleChangeVehicle = (val: { [key: string]: any }) => {
  if (val.length && val[0] && val[0].type && val[0].type.length) {
    dataFormAddVehicle.typeFleetVehicle = val[0].type
    return
  }
  dataFormAddVehicle.typeFleetVehicle = null
}

const findDrivers = async (s: string) => {
  const api: any = $url.driver.driver.selectByLicenseType

  const res = await $api(api, {
    query: {
      key: s,
      licenseType: dataFormAddVehicle.licenseType
    }
  })
  const resData: any = res?.data.value
  if (resData.success) {
    return resData.data
  }
  return null
}

const handelChangeLicenseType = (val: any) => {
  dataFormAddVehicle.driver = null
  dataFormAddVehicle.driverName = ''
  dataFormAddVehicle.coDriver = null
  dataFormAddVehicle.coDriverName = ''
}
</script>
